/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { ContactusPage } from './public/ContactusPage'
import AboutusPage from './public/AboutusPage'
import TosPage from './public/TosPage'
import PrivacyPolicyPage from './public/ProivacyPolicyPage'
import LoginPage from './public/LoginPage'
import DashboardPage from './guarded/features/dashboard/DashboardPage'
import MainGuardRoute from '../guards/MainGuardRoute'
import RegisterPage from './public/RegisterPage'
import GuardedRoute from '../guards/GuardedRoute'
import AccountPage from './guarded/features/auth/AccountPage'
import OrganizationApplicationPage from './guarded/features/organization/OrganizationApplicationPage' 
import RouterLogin from './guarded/features/routerAuth/RouterAuth'

const Pages = () => {

  return (
    <Routes>
      {/* Main Routes */}
      <Route exact path="/" element={<MainGuardRoute />} />
      <Route exact path="/dashboard" element={<GuardedRoute><DashboardPage /></GuardedRoute>} />
      <Route exact path="/organizations/applications/:orgid" element={<GuardedRoute> <OrganizationApplicationPage /> </GuardedRoute>} />
      <Route exact path="/organizations/applications" element={<GuardedRoute> <OrganizationApplicationPage /> </GuardedRoute>} />
           <Route exact path="/router" element={<GuardedRoute><RouterLogin /></GuardedRoute>} />



      {/* Account & Authentication */}

      <Route exact path="/login" element={<LoginPage />} />
      {process.env.REACT_APP_REGISTER_MODE === 'true' && (
        <Route exact path="/register" element={<RegisterPage />} />
      )}
      <Route exact path={"/account"} element={<GuardedRoute><AccountPage /></GuardedRoute>} />

      {/* Public Pages */}

      <Route exact path="/contact-us" element={<ContactusPage />} />
      <Route exact path="/about-us" element={<AboutusPage />} />
      <Route exact path="/tos" element={<TosPage />} />
      <Route exact path="/privacypolicy" element={<PrivacyPolicyPage />} />

    </Routes>
  )

}



export default Pages